<template>
  <form role="form" aria-label="phone-authentication">
    <base-input
        v-model="phoneNumber" type="text"
        pattern="\d*"
        form-classes="input-group-alternative mb-2 phone-input"
        style="display: flex;border-radius: 0;"
        :placeholder="$t('Phone Number')"
        :disabled="codeSent"
    >
      <template #addonLeft>
        <i class="fa fa-phone pe-2"></i>
        <multiselect
            v-model="countryCode"
            :disabled="codeSent"
            :custom-label="customLabel"
            :options="countryCodes"
            placeholder=""
            :show-labels="false"
            required
            :multiple="false"
            class=""
        >
          <template #singleLabel="{ option }">
            <img v-if="option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+option.iso.toUpperCase()+'.png')" />
            <span class="ps-1" style="line-height: 31px">{{ option.code }}</span>
          </template>
          <template #option="props">
            <img v-if="props.option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+props.option.iso.toUpperCase()+'.png')" />
            {{ props.option.text }}
          </template>
        </multiselect>
      </template>
      <template v-if="codeSent" #addonRight>
        <base-button size="sm" class="p-0" type="link" @click="resetAuthForm">Edit </base-button>
      </template>
    </base-input>

    <label v-if="isPhoneValid === false" class="row ms-1 text-danger text-sm mb-2">{{ $t("Must be a valid phone number") }}</label>
    <base-input
        v-if="codeSent"
        v-model="code"
        type="text"
        pattern="\d*"
        form-classes="input-group-alternative mb-3"
        :placeholder="$t('Verification Code')"
        addon-left-icon="fa fa-key"
    >
    </base-input>
    <base-alert v-if="showAlert" :type="alertType">
      <strong></strong> {{ $t(alertMessage) }}
    </base-alert>
    <!--            <base-checkbox class="custom-control-alternative">-->
    <!--              <span class="text-muted">Remember me</span>-->
    <!--            </base-checkbox>-->
    <div class="text-center pt-3">
      <base-button v-if="!codeSent" class="pb-2" :disabled="sendingCodeStatus" type="primary" @click="getCode">
        <template v-if="sendingCodeStatus">
          <span class="fas fa-cog fa-spin" aria-hidden="true"></span>
        </template>
        <template v-else> {{ $t("Get verification code") }} </template>
      </base-button>
      <base-button v-else type="primary" :disabled="code.length !== 6 || signInLoader" class="mt-4 mb-2" @click="signIn">
        <template v-if="signInLoader">
          <span class="fas fa-cog fa-spin" aria-hidden="true"></span>
        </template>
        <template v-else>
          {{ $t("Submit Code") }}
        </template>
      </base-button>
    </div>
    <div id="recaptcha-container"></div>
  </form>
</template>

<script>
import BaseInput from "@/components/BaseInput"
import BaseButton from "@/components/BaseButton"
import {isWindows} from "@/helpers/common"
import {
  RecaptchaVerifier,
  getAuth,
  signInWithPhoneNumber,
} from "firebase/auth"
import { isValidNumber, getCountries, getCountryCallingCode } from "libphonenumber-js"
import BaseAlert from "@/components/BaseAlert"
export default {
  name: "PhoneAuth",
  components: {BaseAlert, BaseButton, BaseInput},
  data() {
    return {
      isWindows,
      countryCodes: [],
      countryCode: {code: "+357", text: this.$t("CY") + " +357", iso: "CY"},
      isPhoneValid: null,
      showAlert: false,
      alertType: "",
      alertMessage: "",
      signInLoader: false,
      sendingCodeStatus: false,
      codeSent: false,
      phoneNumber: "",
      code: "",
      recaptchaVerifier: null,
      confirmationResult: null,
      // showModal: false
    }
  },
  watch:{
    "phoneNumber": function (newVal) {
      this.isPhoneValid = isValidNumber(this.countryCode?.code+newVal)
    },
    "countryCode": function (newVal) {
      this.isPhoneValid = isValidNumber(newVal+this.phoneNumber)
    }
  },
  mounted() {
    this.recaptchaVerifier = new RecaptchaVerifier(
        getAuth(this.fireApp),
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            console.log("reca response", response)
            // reCAPTCHA solved, allow signInWithPhoneNumber.
          },
        },
    )
    let countries = ["CY", "GB", "GR"]

    countries.forEach( country => {
      let code = getCountryCallingCode(country)
      this.countryCodes.push({code: "+" + code, text: this.$t(country) + " +" + code, iso: country})
    })
  },
  methods: {
    customLabel(option) {
      return `${option.text}`
    },
    resetModal() {
      this.phoneNumber = ""
      this.codeSent = false
      this.showAlert = false
      this.clearAlert()
    },
    initAlert(type, message) {
      this.showAlert = true
      this.alertType = type
      this.alertMessage = message
    },
    clearAlert() {
      this.showAlert = false
      this.alertType = ""
      this.alertMessage = ""
    },
    getCode() {
      let self = this
      this.clearAlert()
      let userPhone = ""

      if (this.isPhoneValid === true) {
        userPhone = this.countryCode.code+this.phoneNumber
      } else {
        this.isPhoneValid = false
        console.log("Invalid phone")
        return
      }

      this.sendingCodeStatus = true
      let auth = getAuth(this.fireApp)

      console.log("userPhone", userPhone)
      signInWithPhoneNumber(auth, userPhone, this.recaptchaVerifier)
          .then((confirmationResult) => {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            self.codeSent = true
            self.initAlert("info", "The 6-digit code has been sent to the mobile number given.")
            this.sendingCodeStatus = false
            self.confirmationResult = confirmationResult
            // ...
          })
          .catch((error) => {
            console.log("error, erroe", error)
            console.log("error.code", error.code)
            this.sendingCodeStatus = false
            let message = error.message
            if(error.code === "auth/invalid-phone-number") {
              message = "The phone number given is not valid."
            }
            if(error.code === "auth/admin-restricted-operation") {
              message = "It looks like you don't have an account yet. Please try to register instead."
            }
            if(error.code === "auth/code-expired") {
              message = "The verification code has expired. Please request a new code."
            }
            if (error.code === "auth/app-not-authorized") {
              message = "This application is not authorized to access the requested service. Please contact support for assistance."
            }
            self.initAlert("danger", message)
            // Error SMS not sent
          })
    },
    resetAuthForm(){
      this.codeSent = false
      this.showAlert = false
    },
    signIn() {
      let self = this
      this.clearAlert()
      this.signInLoader = true
      this.confirmationResult
          .confirm(this.code)
          .then(async (result) => {

            result.user.getIdToken().then((idToken) => {
              console.log("Firebase ID Token:", idToken)
            })
            // User signed in successfully.
            console.log("res", result.user)
            // await store.dispatch("fetchUser", user)
            // await store.dispatch("fetchClient", {companyId: self.$route.params.id, userId: user.uid})
            // self.resetModal()
            // Send user to previous path
            // await this.$router.push({path: "/dashboard"})
            // ...
          })
          .catch((error) => {
            this.signInLoader = false
            // User couldn't sign in (bad verification code?)
            let message = error.message
            if (error.code === "auth/invalid-verification-code") {
              message = "Verification code is invalid."
            }
            self.initAlert("danger", message)
          })
    },
  },
}
</script>

<style scoped>

</style>